import ColumnManagementModal from './ColumnManagementModal'

export default ColumnManagementModal
